import React, { Component } from 'react';
import { Grid, Button, Typography, Box, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@material-ui/core';
import '../CSS/Transactions.css';
import {
    getTransactions, updateTransaction, cardConnectInquire, getCardType,
    cardConnectVoid, cardConnectRefund, getIntegrations, recordPayment, stripeRefund
} from '../utils/OpenCampground_Database_Calls';
import { getPayment, returnVoid, partialRefund } from '../utils/MxMerchant_Services'
import SearchBar from "material-ui-search-bar";
import { withStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Select, MenuItem } from '@mui/material';
import Print from './Print';
import transactions from '../assets/transactions.png'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { format } from 'date-fns';
import { useLocation } from 'react-router-dom';

const useStyles = theme => ({
    circularProgress: {
        position: 'absolute',
        left: '55%',
        top: '50%',
        color: '#2dcd7a'
    },
    dialogPaper: {
        padding: theme.spacing(2),
        borderRadius: '10px',
    },
    printPaper: {
        padding: theme.spacing(2),
        borderRadius: '10px',
        width: '5000px'
    }
});

const numericFields = new Set(['reservation_id', 'credit_card_no', 'memo', 'amount']);

const theme = createTheme({
    palette: {
        primary: {
            main: '#2dcd7a',
        },
    },
});

class Transactions extends Component {

    constructor(props) {
        super(props);
        this.state = {
            allTransactions: [],
            transitions: [],
            currentPage: '1',
            searchValue: '',
            searchBy: 'id',
            open: false,
            confirm: false,
            popupText: '',
            popupTitle: '',
            transactionToHandel: "",
            confirmationOpen: false,
            confirmationText: '',
            confirmPoputTitle: '',
            paymentIntegration: [],
            noTransactions: false,
            printOpen: false,
            printItem: {},

            referenceNumberToVoidorReturn: '',
            transactionVoidable: false,
            fullRefund: null,
            partialRefund: null,
            partialRefundAmt: '',
            campPayId: '',
            noPastTransactions: false,
            open1: false,
            open1Text: '',
            open1Title: '',
            sortConfig: {
                key: null,
                direction: 'asc'
            },
        };
    }

    async componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const searchValue = urlParams.get("searchValue");
        console.log("searchValue: ", searchValue)
        this.getTransactions()
        let paymentIntegration = await getIntegrations(this.props.user, this.props.serverName)
        this.setState({
            paymentIntegration: paymentIntegration,
            searchValue: searchValue
        })
        if (searchValue) {
            urlParams.delete("searchValue");
            const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
            window.history.replaceState({}, "", newUrl);
            this.getTransactionsByReservationNumber(searchValue)
        }
    }

    getTransactions = async () => {
        let listOfTransactions = await getTransactions(this.props.user, this.props.serverName);
        console.log("List Of Transactions: ", listOfTransactions)
        this.setState({
            allTransactions: listOfTransactions,
            transitions: listOfTransactions,
            noPastTransactions: listOfTransactions?.length === 0
        })
    }

    getTransactionsByReservationNumber = async (value) => {
        const searchValue = value.toString();
        const filteredTransactions = this.state.allTransactions.filter(transaction => {
            return (
                (transaction?.reservation_id && transaction?.reservation_id?.toString().includes(searchValue)) ||
                (transaction?.amount && `$${transaction.amount}`.includes(searchValue)) ||
                (transaction?.credit_card_no && transaction?.credit_card_no?.toString().includes(searchValue))
            );
        });
        if (filteredTransactions.length < 1) {
            this.setState({
                value: '',
                noTransactions: true,
            });
        } else {
            this.setState({
                value: '',
                transitions: filteredTransactions,
                noTransactions: false
            });
        }
    }

    getTransactionsByLast4 = async (value) => {
        const searchValue = value.toString();
        const filteredTransactions = this.state.allTransactions.filter(transaction => {
            const reservationId = (transaction.credit_card_no || '').toString();
            return reservationId.includes(searchValue);
        });
        if (filteredTransactions.length < 1) {
            this.setState({
                value: '',
                noTransactions: true,
            });
        } else {
            this.setState({
                value: '',
                transitions: filteredTransactions,
                noTransactions: false
            });
        }
    }

    displayAllTransactions = async () => {
        this.setState({
            transitions: this.state.allTransactions,
            noTransactions: false
        })
    }

    refundVoid = async (item) => {
        console.log("item: ", item)
        if (item.card_type === 'Cash' || item.card_type === 'Check' || item.card_type === 'Others') {
            this.setState({
                open1: true,
                transactionToHandel: item,
                open1Text: 'Do you want to make a refund of $' + item.amount + '?',
                open1Title: 'Refund Transaction'
            })
        } else {
            let authorizationCode = item.memo;
            let referenceNumber = authorizationCode.match(/\d+/)[0];
            let popupText
            let campPayId = ''
            let transactionVoidable
            let popupTitle
            if (item.memo.includes('pi')) {
                // let inquireResponse = await cardConnectInquire(this.props.user, this.state.paymentIntegration.cc_merchant_id, referenceNumber, this.state.paymentIntegration.cc_api_username, this.state.paymentIntegration.cc_api_password)
                // console.log("inquireResponse: ", inquireResponse)
                popupText = 'Do you want to refund a partial amount or the full amount of $' + item.amount + '?'
                transactionVoidable = false
                popupTitle = "Refund Transaction"
            } else if (this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o' || this.state.paymentIntegration.name === 'CampPay_r') {
                let getTransactionData = await getPayment(this.state.paymentIntegration.cp_merchantid, referenceNumber)
                console.log("getTransactionData: ", getTransactionData)
                campPayId = getTransactionData.records[0].id
                if (getTransactionData.records[0].status === 'Settled') {
                    popupText = 'Do you want to refund a partial amount or the full amount of $' + item.amount + '?'
                    transactionVoidable = false
                    popupTitle = "Refund Transaction"
                } else {
                    popupText = 'Void Transaction for amount $' + item.amount
                    transactionVoidable = true
                    popupTitle = "Void Transaction"
                }
            } else if (this.state.paymentIntegration.name === 'CardConnect' || this.state.paymentIntegration.name === 'CardConnect_o' || this.state.paymentIntegration.name === 'CardConnect_r') {
                let inquireResponse = await cardConnectInquire(this.props.user, this.state.paymentIntegration.cc_merchant_id, referenceNumber, this.state.paymentIntegration.cc_api_username, this.state.paymentIntegration.cc_api_password)
                console.log("inquireResponse: ", inquireResponse)
                if (inquireResponse.voidable === 'Y') {
                    popupText = 'Void Transaction for amount $' + item.amount
                    transactionVoidable = true
                    popupTitle = "Void Transaction"
                } else {
                    popupText = 'Do you want to refund a partial amount or the full amount of $' + item.amount + '?'
                    transactionVoidable = false
                    popupTitle = "Refund Transaction"
                }
            }
            this.setState({
                open: true,
                transactionToHandel: item,
                popupText: popupText,
                referenceNumberToVoidorReturn: referenceNumber,
                campPayId: campPayId,
                transactionVoidable: transactionVoidable,
                popupTitle: popupTitle
            })
        }
    }

    handleConfirm = async () => {
        const { transactionToHandel } = this.state;
        console.log("transactionToHandel: ", transactionToHandel)
        this.setState({ confirm: true, open: false }, async () => {
            let confirmationText
            let confirmPoputTitle
            if (transactionToHandel.memo.includes('pi')) {
                if (this.state.transactionVoidable) {
                    let voidResponse = await cardConnectVoid(this.props.user, this.state.paymentIntegration.cc_merchant_id, this.state.referenceNumberToVoidorReturn, this.state.paymentIntegration.cc_api_username, this.state.paymentIntegration.cc_api_password)
                    if (voidResponse.resptext === "Approval") {
                        let updatedtransactions = await updateTransaction(this.props.user, this.props.serverName, transactionToHandel.id)
                        // call recordPayment api with memo as Voided
                        const amount = -transactionToHandel.amount
                        let cardId = await getCardType(transactionToHandel.card_type)
                        let paymentRecords = await recordPayment(this.props.user, this.props.serverName, amount, transactionToHandel.reservation_id,
                            format(new Date(), 'yyyy-MM-dd HH:mm:ss'), format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                            "Voided: " + transactionToHandel.memo, cardId, transactionToHandel.credit_card_no, transactionToHandel.name, format(new Date(), 'yyyy-MM-dd HH:mm:ss'), 0, ""
                        )
                        confirmPoputTitle = 'Transaction voided successfully'
                        confirmationText = 'Succcessfully Voided $' + (transactionToHandel.amount).toFixed(2) + ' for reservation Number: ' + transactionToHandel.reservation_id
                        this.getTransactions()
                    } else {
                        confirmPoputTitle = 'Error'
                        confirmationText = 'This transaction could not be voided at this time. This could be due to a network or communication error with your credit card processor. Please try again.'
                    }
                } else {
                    let refundAmt
                    if (this.state.fullRefund) {
                        refundAmt = transactionToHandel.amount
                    } else {
                        refundAmt = this.state.partialRefundAmt
                    }
                    let returnResponse = await stripeRefund(refundAmt, transactionToHandel.memo)
                    if (returnResponse.refund.status === "succeeded") {
                        let updatedtransactions = await updateTransaction(this.props.user, this.props.serverName, transactionToHandel.id)
                        // call recordPayment api with memo as Refunded
                        const amount = -refundAmt
                        let cardId = await getCardType(transactionToHandel.card_type)
                        let paymentRecords = await recordPayment(this.props.user, this.props.serverName, amount, transactionToHandel.reservation_id,
                            format(new Date(), 'yyyy-MM-dd HH:mm:ss'), format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                            "Refunded: " + transactionToHandel.memo, cardId, transactionToHandel.credit_card_no, transactionToHandel.name, format(new Date(), 'yyyy-MM-dd HH:mm:ss'), 0, returnResponse.refund.id
                        )
                        confirmPoputTitle = 'Transaction refunded successfully'
                        confirmationText = 'Succcessfully Refunded $' + refundAmt + ' for reservation Number: ' + transactionToHandel.id
                        this.getTransactions()
                    } else {
                        confirmPoputTitle = 'Error'
                        confirmationText = 'This transaction could not be refunded at this time. This could be due to a network or communication error with your credit card processor. Please try again.'
                    }
                }
            } else if (this.state.paymentIntegration.name === 'CampPay' || this.state.paymentIntegration.name === 'CampPay_o' || this.state.paymentIntegration.name === 'CampPay_r') {
                if (this.state.transactionVoidable) {
                    let returnVoidData = await returnVoid(this.state.campPayId)
                    if (returnVoidData.status === 204) {
                        let updatedtransactions = await updateTransaction(this.props.user, this.props.serverName, transactionToHandel.id)
                        // call recordPayment api with memo as Voided
                        const amount = -transactionToHandel.amount
                        let cardId = await getCardType(transactionToHandel.card_type)
                        let paymentRecords = await recordPayment(this.props.user, this.props.serverName, amount, transactionToHandel.reservation_id,
                            format(new Date(), 'yyyy-MM-dd HH:mm:ss'), format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                            "Voided: " + transactionToHandel.memo, cardId, transactionToHandel.credit_card_no, transactionToHandel.name, format(new Date(), 'yyyy-MM-dd HH:mm:ss'), 0, ""
                        )
                        confirmPoputTitle = 'Transaction voided successfully'
                        confirmationText = 'Succcessfully Voided $' + transactionToHandel.amount + ' for reservation Number: ' + transactionToHandel.reservation_id
                        this.getTransactions()
                    } else {
                        confirmPoputTitle = 'Error'
                        confirmationText = 'This transaction could not be voided at this time. This could be due to a network or communication error with your credit card processor. Please try again.'
                    }
                } else {
                    let refundAmt
                    if (this.state.fullRefund) {
                        refundAmt = -transactionToHandel.amount
                    } else {
                        refundAmt = -this.state.partialRefundAmt
                    }
                    let partialRefundResponse = await partialRefund(this.state.paymentIntegration.cp_merchantid, refundAmt, transactionToHandel.token)
                    if (partialRefundResponse.status === "Approved") {
                        let updatedtransactions = await updateTransaction(this.props.user, this.props.serverName, transactionToHandel.id)
                        // call recordPayment api with memo as Refunded
                        let cardId = await getCardType(transactionToHandel.card_type)
                        let paymentRecords = await recordPayment(this.props.user, this.props.serverName, refundAmt, transactionToHandel.reservation_id,
                            format(new Date(), 'yyyy-MM-dd HH:mm:ss'), format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                            "Refunded: " + partialRefundResponse.reference, cardId, transactionToHandel.credit_card_no, transactionToHandel.name, format(new Date(), 'yyyy-MM-dd HH:mm:ss'), 0, ""
                        )
                        confirmPoputTitle = 'Transaction refunded successfully'
                        confirmationText = 'Succcessfully Refunded $' + refundAmt + ' for reservation Number: ' + transactionToHandel.reservation_id
                        this.getTransactions()
                    } else {
                        confirmPoputTitle = 'Error'
                        confirmationText = 'This transaction could not be refunded at this time. This could be due to a network or communication error with your credit card processor. Please try again.'
                    }
                }
            } else if (this.state.paymentIntegration.name === 'CardConnect' || this.state.paymentIntegration.name === 'CardConnect_o' || this.state.paymentIntegration.name === 'CardConnect_r') {
                if (this.state.transactionVoidable) {
                    let voidResponse = await cardConnectVoid(this.props.user, this.state.paymentIntegration.cc_merchant_id, this.state.referenceNumberToVoidorReturn, this.state.paymentIntegration.cc_api_username, this.state.paymentIntegration.cc_api_password)
                    if (voidResponse.resptext === "Approval") {
                        let updatedtransactions = await updateTransaction(this.props.user, this.props.serverName, transactionToHandel.id)
                        // call recordPayment api with memo as Voided
                        const amount = -transactionToHandel.amount
                        let cardId = await getCardType(transactionToHandel.card_type)
                        let paymentRecords = await recordPayment(this.props.user, this.props.serverName, amount, transactionToHandel.reservation_id,
                            format(new Date(), 'yyyy-MM-dd HH:mm:ss'), format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                            "Voided: " + transactionToHandel.memo, cardId, transactionToHandel.credit_card_no, transactionToHandel.name, format(new Date(), 'yyyy-MM-dd HH:mm:ss'), 0, ""
                        )
                        confirmPoputTitle = 'Transaction voided successfully'
                        confirmationText = 'Succcessfully Voided $' + (transactionToHandel.amount).toFixed(2) + ' for reservation Number: ' + transactionToHandel.reservation_id
                        this.getTransactions()
                    } else {
                        confirmPoputTitle = 'Error'
                        confirmationText = 'This transaction could not be voided at this time. This could be due to a network or communication error with your credit card processor. Please try again.'
                    }
                } else {
                    let refundAmt
                    if (this.state.fullRefund) {
                        refundAmt = transactionToHandel.amount
                    } else {
                        refundAmt = this.state.partialRefundAmt
                    }
                    let returnResponse = await cardConnectRefund(this.props.user, this.state.paymentIntegration.cc_merchant_id, this.state.referenceNumberToVoidorReturn, refundAmt, this.state.paymentIntegration.cc_api_username, this.state.paymentIntegration.cc_api_password)
                    if (returnResponse.resptext === "Approval") {
                        let updatedtransactions = await updateTransaction(this.props.user, this.props.serverName, transactionToHandel.id)
                        // call recordPayment api with memo as Refunded
                        const amount = -refundAmt
                        let cardId = await getCardType(transactionToHandel.card_type)
                        let paymentRecords = await recordPayment(this.props.user, this.props.serverName, amount, transactionToHandel.reservation_id,
                            format(new Date(), 'yyyy-MM-dd HH:mm:ss'), format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                            "Refunded: " + transactionToHandel.memo, cardId, transactionToHandel.credit_card_no, transactionToHandel.name, format(new Date(), 'yyyy-MM-dd HH:mm:ss'), 0, ""
                        )
                        confirmPoputTitle = 'Transaction refunded successfully'
                        confirmationText = 'Succcessfully Refunded $' + refundAmt + ' for reservation Number: ' + transactionToHandel.id
                        this.getTransactions()
                    } else {
                        confirmPoputTitle = 'Error'
                        confirmationText = 'This transaction could not be refunded at this time. This could be due to a network or communication error with your credit card processor. Please try again.'
                    }
                }
            }
            this.setState({
                confirmationOpen: true,
                confirmationText: confirmationText,
                confirmPoputTitle: confirmPoputTitle
            })
        });
    };

    returnCashCheck = async () => {
        const { transactionToHandel } = this.state;
        this.setState({
            open1: false
        }, async () => {
            let paymentRecords = await recordPayment(this.props.user, this.props.serverName, -transactionToHandel.amount, transactionToHandel.reservation_id,
                format(new Date(), 'yyyy-MM-dd HH:mm:ss'), format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                "Refunded", transactionToHandel.card_type === 'Cash' ? '1' : '2', "", "", format(new Date(), 'yyyy-MM-dd HH:mm:ss'), 0, ""
            )
            let confirmPoputTitle = 'Transaction refunded successfully'
            let confirmationText = 'Succcessfully Refunded $' + transactionToHandel.amount + ' for reservation Number: ' + transactionToHandel.reservation_id
            this.getTransactions()
            this.setState({
                confirmationOpen: true,
                confirmationText: confirmationText,
                confirmPoputTitle: confirmPoputTitle
            })
        })
    }

    handleCancel = () => {
        this.setState({
            confirm: false,
            open: false,
            printOpen: false,
            fullRefund: null,
            partialRefund: null,
            partialRefundAmt: ''
        });
    };

    print = async (item) => {
        this.setState({
            printItem: item,
            printOpen: true
        });
    }

    goBack = () => {
        this.setState({
            printOpen: false,
        });
        this.getTransactions()
    }

    partialAmtChnage = (event) => {
        this.setState({
            partialRefundAmt: event.target.value
        })
    }

    handleSort = (columnKey) => {
        this.setState((prevState) => {
          const { sortConfig } = prevState;
          if (sortConfig.key === columnKey) {
            if (sortConfig.direction === 'asc') {
              return { sortConfig: { key: columnKey, direction: 'desc' } };
            } else if (sortConfig.direction === 'desc') {
              return { sortConfig: { key: null, direction: null } };
            }
          }
          return { sortConfig: { key: columnKey, direction: 'asc' } };
        });
    };

    render() {
        const { classes } = this.props;
        const itemsPerPage = 15;
        const totalPages = Math.ceil(this.state.transitions.length / itemsPerPage);
        let currentPage = this.state.currentPage || 1;

        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = Math.min(startIndex + itemsPerPage, this.state.transitions.length);

        const sortedTransaction = this.state.transitions.slice(startIndex, endIndex);

        const { key, direction } = this.state.sortConfig;
        if (key && direction) {
            sortedTransaction.sort((a, b) => {
                let valA = a[key];
                let valB = b[key];
                const isNumeric = numericFields.has(key);
                if (isNumeric) {
                    console.log(valA, valB);
                    valA = parseFloat(valA)||0;
                    valB = parseFloat(valB)||0;
                    console.log(valA, valB);
                } else {
                    valA = valA?.toLowerCase() || '';
                    valB = valB?.toLowerCase() || '';
                    
                }
                if (valA < valB) return direction === 'asc' ? -1 : 1;
                if (valA > valB) return direction === 'asc' ? 1 : -1;
                return 0;
            });
        }

        let transactionsRows = sortedTransaction.map((item) => {
            return (
                <tr key={item.id} className='rows'>
                    <td>{item.reservation_id}</td>
                    <td>{"$"}{parseFloat(item.amount).toFixed(2)}</td>
                    <td>{item.pmt_date}</td>
                    <td>{item.card_type === "Others" && item?.memo?.split(':')[0] ? item.memo.split(':')[0] : item.card_type}</td>
                    <td>{item.credit_card_no}</td>
                    <td>{item.memo}</td>
                    <td>{item.name}</td>
                    <td>
                        {item.refundable === 1
                            ?
                            <Button
                                onClick={() => this.refundVoid(item)}
                                style={{ backgroundColor: '#d4d4d4', color: 'black', padding: '2% 10% 2% 10%', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}
                            >
                                Void/Refund
                            </Button>
                            : null}

                    </td>
                    <td>
                        <Button
                            onClick={() => this.print(item)}
                            style={{ backgroundColor: '#d4d4d4', color: 'black', padding: '2% 10% 2% 10%', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}
                        >
                            Receipt
                        </Button>
                    </td>
                </tr>
            );
        });

        const paginationButtons = [];
        const maxButtonsToShow = 10;
        let startPage, endPage;

        if (totalPages <= maxButtonsToShow) {
            startPage = 1;
            endPage = totalPages;
        } else {
            const maxPagesBeforeCurrentPage = Math.floor(maxButtonsToShow / 2);
            const maxPagesAfterCurrentPage = Math.ceil(maxButtonsToShow / 2) - 1;
            if (currentPage <= maxPagesBeforeCurrentPage) {
                startPage = 1;
                endPage = maxButtonsToShow;
            } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
                startPage = totalPages - maxButtonsToShow + 1;
                endPage = totalPages;
            } else {
                startPage = currentPage - maxPagesBeforeCurrentPage;
                endPage = currentPage + maxPagesAfterCurrentPage;
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            paginationButtons.push(
                <Button className={`paginationButton ${currentPage === i ? "activePage" : ""}`} key={i} onClick={() => this.setState({ currentPage: i })}>
                    {i}
                </Button>
            );
        }

        const previousButton = (
            <Button className='previousButton' disabled={currentPage === 1} onClick={() => this.setState({ currentPage: currentPage - 1 })}>
                <ArrowBackIosIcon />
            </Button>
        );

        const nextButton = (
            <Button className='nextButton' disabled={currentPage === totalPages} onClick={() => this.setState({ currentPage: currentPage + 1 })}>
                <ArrowForwardIosIcon />
            </Button>
        );

        const lastButton = (
            <Button className='paginationButton' disabled={currentPage === totalPages} onClick={() => this.setState({ currentPage: totalPages })}>
                {totalPages}
            </Button>
        );

        if (this.state.printOpen) {
            return (
                <Print serverName={this.props.serverName} goBack={this.goBack} printItem={this.state.printItem} user={this.props.user} />
            );
        } else if (this.state.transitions.length >= 1 || this.state.noTransactions) {
            return (
                <Grid className='transactionsList'>
                    <ThemeProvider theme={theme}>
                        <Dialog open={this.state.open} onClose={this.handleCancel} classes={{ paper: classes.dialogPaper }}>
                            <DialogTitle>{this.state.popupTitle}</DialogTitle>
                            <DialogContent>
                                {this.state.popupText}
                                {!this.state.transactionVoidable
                                    ?
                                    <div style={{ marginTop: '5%' }}>
                                        {this.state.partialRefund
                                            ?
                                            <div style={{ display: 'flex', gap: '50px', alignItems: 'center' }}>
                                                <TextField id="partialRefundAmt" required label="Parital Amount" type="number"
                                                    value={this.state.partialRefundAmt}
                                                    onChange={this.partialAmtChnage} />
                                                <Button onClick={this.handleConfirm}
                                                    style={{ backgroundColor: '#2dcd7a', color: '#000000', padding: '2% 7% 2% 7%', margin: '0 2% 0 0', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}
                                                >
                                                    Refund
                                                </Button>
                                            </div>
                                            :
                                            null
                                        }
                                    </div>
                                    : null
                                }
                            </DialogContent>
                            <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Button onClick={this.handleCancel} style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}>
                                    Cancel
                                </Button>
                                {!this.state.transactionVoidable
                                    ?
                                    <>
                                        <Button onClick={() => this.setState({ fullRefund: true, partialRefund: false, partialRefundAmt: '' }, this.handleConfirm)}
                                            style={{ backgroundColor: '#d4d4d4', color: '#000000', padding: '2% 7% 2% 7%', margin: '0 2% 0 0', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}
                                        >
                                            Full Refund
                                        </Button>
                                        <Button onClick={() => this.setState({ partialRefund: true, fullRefund: false, partialRefundAmt: '' })}
                                            style={{ backgroundColor: '#d4d4d4', color: '#000000', padding: '2% 7% 2% 7%', margin: '0 2% 0 0', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}
                                        >
                                            Partial Refund
                                        </Button>
                                    </>
                                    : <Button onClick={this.handleConfirm} style={{ backgroundColor: '#2dcd7a', color: '#000000', padding: '2% 10% 2% 10%', margin: '0 2% 0 0', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}>
                                        Confirm
                                    </Button>
                                }
                            </DialogActions>
                        </Dialog>

                        <Dialog open={this.state.open1} onClose={() => { this.setState({ open1: false }) }} classes={{ paper: classes.dialogPaper }}>
                            <DialogTitle>{this.state.open1Title}</DialogTitle>
                            <DialogContent>
                                {this.state.open1Text}
                            </DialogContent>
                            <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Button onClick={() => { this.setState({ open1: false }) }} style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}>
                                    Cancel
                                </Button> <Button onClick={this.returnCashCheck} style={{ backgroundColor: '#2dcd7a', color: '#000000', padding: '2% 10% 2% 10%', margin: '0 2% 0 0', borderRadius: '10px', marginTop: '3%', textTransform: "capitalize" }}>
                                    Confirm
                                </Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog open={this.state.confirmationOpen} onClose={() => this.setState({ confirmationOpen: false })} classes={{ paper: classes.printPaper }}>
                            <DialogTitle>{this.state.confirmPoputTitle}</DialogTitle>
                            <DialogContent>
                                {this.state.confirmationText}
                            </DialogContent>
                            <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Button onClick={() => this.setState({ confirmationOpen: false })} style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%' }}>
                                    Cancel
                                </Button>
                            </DialogActions>
                        </Dialog>

                        <Box className='infoBox'>
                            <Typography className='infoBarTypo'>Welcome: {this.props.serverName.charAt(0).toUpperCase() + this.props.serverName.slice(1)}</Typography>
                            <Typography className='infoBarTypo'>Username: {this.props.user}</Typography>
                        </Box>

                        <Box className='box'>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={transactions} alt="Transactions" style={{ height: '40px', width: '40px' }} />
                                <Typography className='transactionstypography' style={{ marginLeft: '5%' }}>Transactions</Typography>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', width: '50%' }}>
                                {this.state.searchBy === "id"
                                    ? <div style={{ width: '100%' }}>
                                        <SearchBar
                                            className='searchBox'
                                            placeholder='e.g. reservation number, amount, last 4'
                                            value={this.state.searchValue}
                                            onChange={(newValue) => this.setState({ searchValue: newValue })}
                                            onRequestSearch={() => this.getTransactionsByReservationNumber(this.state.searchValue)}
                                            cancelOnEscape={true}
                                            onCancelSearch={() => this.displayAllTransactions()}
                                        />
                                    </div>
                                    : <div>
                                        <SearchBar
                                            className='searchBox'
                                            placeholder='Search By Last4'
                                            value={this.state.searchValue}
                                            onChange={(newValue) => this.setState({ searchValue: newValue })}
                                            onRequestSearch={() => this.getTransactionsByLast4(this.state.searchValue)}
                                            cancelOnEscape={true}
                                            onCancelSearch={() => this.displayAllTransactions()}
                                        />
                                    </div>
                                }
                            </div>
                        </Box>
                    </ThemeProvider>

                    {/* <Box className='tableheadingbox'>
                        <Typography className='headerTypo'>Reservation #</Typography>
                        <Typography className='headerTypo'>Amount</Typography>
                        <Typography className='headerTypo'>Payment Date</Typography>
                        <Typography className='headerTypo'>Payment Method</Typography>
                        <Typography className='headerTypo'>Last 4</Typography>
                        <Typography className='headerTypo'>Reference Number</Typography>
                        <Typography className='headerTypo'>Name</Typography>
                        <Typography className='headerTypo'>Actions</Typography>
                    </Box> */}
                    <Box className='tableheadingbox'>
                            {[
                                { key: 'reservation_id', label: 'Reservation #' },
                                { key: 'amount', label: 'Amount' },
                                { key: 'pmt_date', label: 'Payment Date' },
                                { key: 'card_type', label: 'Payment Method' },
                                { key: 'credit_card_no', label: 'Last 4' },
                            ].map((col) => (
                            <Typography
                            key={col.key}
                            className='headerTypo'
                            onClick={() => this.handleSort(col.key)}
                            style={{ cursor: 'pointer', position: 'relative' }}
                            >
                                {col.label}
                                {this.state.sortConfig.key === col.key ? (
                            <>
                            {this.state.sortConfig.direction === 'asc' ? ' 🔼' : ' 🔽'}
                            </>
                        ) : ''}
                        </Typography>))}
                        <Typography className='headerTypo'>Reference Number</Typography>
                        <Typography
                            key='name'
                            className='headerTypo'
                            onClick={() => this.handleSort('name')}
                            style={{ cursor: 'pointer', position: 'relative' }}
                            >
                                Name
                                {this.state.sortConfig.key === 'name' ? (
                            <>
                            {this.state.sortConfig.direction === 'asc' ? ' 🔼' : ' 🔽'}
                            </>
                        ) : ''}
                        </Typography>
                        <Typography className='headerTypo'>Actions</Typography>
                    </Box>

                    {
                        !this.state.noTransactions
                            ?
                            <>
                                <Box className='tableBox'>
                                    <table>
                                        <tbody>
                                            {transactionsRows}
                                        </tbody>
                                    </table>
                                </Box>
                                <div className="pagination">
                                    {previousButton}
                                    {paginationButtons}
                                    ...
                                    {lastButton}
                                    {nextButton}
                                </div>
                            </>
                            :
                            <>
                                <Typography className='headerTypo' style={{ marginTop: '5%', fontSize: '1.5rem' }}>No Transactions Found</Typography>
                            </>
                    }
                </Grid >
            );
        } else if (this.state.noPastTransactions) {
            return (
                <Grid className='transactionsList'>
                    <Box className='infoBox'>
                        <Typography className='infoBarTypo'>Welcome: {this.props.serverName.charAt(0).toUpperCase() + this.props.serverName.slice(1)}</Typography>
                        <Typography className='infoBarTypo'>Username: {this.props.user}</Typography>
                    </Box>
                    <Box className='box'>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <img src={transactions} alt="Transactions" style={{ height: '40px', width: '40px' }} />
                            <Typography className='transactionstypography' style={{ marginLeft: '5%' }}>Transactions</Typography>
                        </div>
                    </Box>
                    <Typography style={{ marginTop: '2%', fontSize: '1.5rem' }}> You do not have any past transactions.</Typography>
                </Grid>
            );
        } else {
            return (
                <CircularProgress className={classes.circularProgress} />
            );
        }
    };
};

export default withStyles(useStyles)(Transactions);